import { createFileRoute } from "@tanstack/react-router";
import { MobileEditorWithSidebar } from "@papier/mobile-editor";
import { SchemaField } from "@/types";

export const Route = createFileRoute("/mobile-push")({
  component: RouteComponent,
});

const initialSchema: SchemaField[] = [
  {
    id: "1",
    name: "title",
    type: "string",
    required: true,
    description: "The main title of the document",
    examples: ["PhD Thesis", "Research Paper", "Article Title"],
  },
  {
    id: "2",
    name: "author",
    type: "object",
    required: true,
    description: "Author information",
    objectFields: [
      {
        id: "2-1",
        name: "firstName",
        type: "string",
        required: true,
        description: "Author's first name",
        parentId: "2",
        parentType: "object",
      },
      {
        id: "2-2",
        name: "lastName",
        type: "string",
        required: true,
        description: "Author's last name",
        parentId: "2",
        parentType: "object",
      },
      {
        id: "2-3",
        name: "email",
        type: "string",
        required: false,
        description: "Author's email address",
        parentId: "2",
        parentType: "object",
      },
    ],
  },
  {
    id: "3",
    name: "publishedDate",
    type: "date",
    required: false,
    description: "Date when the document was published",
  },
  {
    id: "4",
    name: "status",
    type: "enum",
    required: true,
    description: "Current status of the document",
    enumValues: ["draft", "in-review", "published", "archived"],
  },
  {
    id: "5",
    name: "tags",
    type: "array",
    required: false,
    description: "List of tags for categorization",
    arrayItemType: {
      id: "5-item",
      name: "tag",
      type: "string",
      required: true,
      parentId: "5",
      parentType: "array",
    },
  },
  {
    id: "6",
    name: "isPublic",
    type: "boolean",
    required: true,
    description: "Whether the document is publicly accessible",
  },
  {
    id: "7",
    name: "comments",
    type: "array",
    required: false,
    description: "List of comments on the document",
    arrayItemType: {
      id: "7-item",
      name: "comment",
      type: "object",
      required: true,
      parentId: "7",
      parentType: "array",
      objectFields: [
        {
          id: "7-item-1",
          name: "author",
          type: "string",
          required: true,
          description: "Comment author's name",
          parentId: "7-item",
          parentType: "object",
        },
        {
          id: "7-item-2",
          name: "content",
          type: "string",
          required: true,
          description: "Content of the comment",
          parentId: "7-item",
          parentType: "object",
        },
        {
          id: "7-item-3",
          name: "timestamp",
          type: "date",
          required: true,
          description:
            "Timestamp when the comment was made, in ISO 8601 format (e.g., 2023-10-01T12:00:00Z)",
          parentId: "7-item",
          parentType: "object",
        },
      ],
    },
  },
];

function RouteComponent() {
  const initialContent = "Hi {{author.firstName}}, this is your notification preview!";

  return (
    <div className="relative" style={{ height: "100vh" }}>
      <MobileEditorWithSidebar
        mode="push"
        initialContent={initialContent}
        initialSchema={{ schema: initialSchema, id: "schema1", name: "Document Schema" }}
      />
    </div>
  );
}
